var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPropostas = function SvgPropostas(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#8BA4A1",
    transform: "translate(-22 -396)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0 C27.9,0 36,8.099 36,18 C36,27.9 27.9,36 18,36 C8.1,36 1.42108547e-14,27.9 1.42108547e-14,18 C1.42108547e-14,8.099 8.1,0 18,0 Z M27.458,7.716 L8.542,7.716 L8.542,26.964 C8.542,28.789 10.036,30.283 11.86,30.283 L11.86,30.283 L20.488,30.283 L20.488,26.632 C20.488,24.806 21.982,23.314 23.808,23.314 L23.808,23.314 L27.458,23.314 L27.458,7.716 Z M27.458,24.973 L23.808,24.973 C22.892,24.973 22.147,25.717 22.147,26.632 L22.147,26.632 L22.147,30.283 L27.458,24.973 Z M18.4973,19.4963 L18.4973,21.1553 L12.5243,21.1553 L12.5243,19.4963 L18.4973,19.4963 Z M23.4753,15.5163 L23.4753,17.1753 L12.5243,17.1753 L12.5243,15.5163 L23.4753,15.5163 Z M23.4753,11.5333 L23.4753,13.1923 L12.5243,13.1923 L12.5243,11.5333 L23.4753,11.5333 Z",
    transform: "translate(22 396)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPropostas, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/propostas.17ae1438.svg";
export { ForwardRef as ReactComponent };